import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import FromTemplate from '../../../components/ProposalCreator/FromTemplate';
import { ProposalCreationStatus } from '../reducer';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		proposalCreator: {
			source,
			fromTemplate: {
				selectedTemplate,
				name,
				error,
			},
			fromFile: {
				status,
				percentage,
				error: importingError,
			},
		},
	} = state;

	return {
		...ownProps,
		source,
		selectedTemplate,
		name,
		error,
		isImportingFile: status && [
			ProposalCreationStatus.IMPORTING,
			ProposalCreationStatus.PROCESSING,
		].includes(status),
		importingStatus: status,
		importingPercentage: percentage,
		importingError,
	};
};

export default connect(mapStateToProps)(FromTemplate);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalCreator/FromTemplate/index.tsx